<template>
  <div class="row">
    <div class="col-md-9 admin-page">
      <el-card :header="adminInfo.business_name">
        <!--just add it here to make the style work-->
        <div class="ql-snow">
          <div class="ql-editor">
            <vue-editor style="display:none"> </vue-editor>
            <div v-html="adminInfo.description"></div>
          </div>
        </div>
        <br />
        <address class="admin-address">
          {{ adminInfo.contact_name }}<br />
          ✉️<a :href="'mailto:' + adminInfo.contact_email">{{
            adminInfo.contact_email
          }}</a
          ><br />
          🌐<a :href="adminInfo.website">{{ adminInfo.website }}</a
          ><br />
          {{ adminInfo.address }} <br />
          {{ adminInfo.city }}, {{ adminInfo.country }}, {{ adminInfo.zipcode
          }}<br />
        </address>
      </el-card>
    </div>
    <div class="col-md-3">
      <AdminSidebarComponent></AdminSidebarComponent>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import AdminSidebarComponent from "../components/AdminSidebarComponent";

export default {
  data() {
    return {
      adminInfo: ""
    };
  },
  components: {
    AdminSidebarComponent
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getAdminInfo: function() {
      this.setLoading(true);
      this.$axios
        .get("/cities/admin")
        .then(response => {
          this.adminInfo = response.data;
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    }
  },
  mounted: function() {
    this.getAdminInfo();
  }
};
</script>
<style>
.admin-address {
  color: gray;
}
</style>
